import { render, staticRenderFns } from "./MB.vue?vue&type=template&id=2e00fdfa&scoped=true"
import script from "./MB.vue?vue&type=script&lang=js"
export * from "./MB.vue?vue&type=script&lang=js"
import style0 from "./MB.vue?vue&type=style&index=0&id=2e00fdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00fdfa",
  null
  
)

export default component.exports